
import React from 'react';

const Privacy = () => {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-bitcoin-accent mb-6">Privacy Policy</h1>
      <p className="text-white/60 mb-8">Effective Date: May 1, 2025</p>

      <div className="prose prose-invert max-w-none">
        <h2 className="text-2xl font-semibold text-web3-green mb-4">1. Introduction</h2>
        <p className="mb-4">
          The Bitcoin Mining Career Simulator ("Simulator") is developed and operated by The Blockchain Academy Inc.
          This Privacy Policy explains how we collect, use, store, and protect your information when you access or use the Simulator.
          By using the Simulator, you consent to the practices described in this Policy.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">2. Information We Collect</h2>
        <p className="mb-4">
          When you interact with the Simulator, we collect certain types of information you voluntarily provide or generate through usage. 
          This may include simulation progress, career path selections, performance metrics, learning preferences, and interaction patterns within the platform.
        </p>
        <p className="mb-4">
          We collect this information to create a personalized and meaningful learning experience for each user.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">3. How We Use Your Information</h2>
        <p className="mb-4">
          We use the information we collect for educational and operational purposes, including:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>Delivering and improving the Simulator experience.</li>
          <li>Tracking your progress to personalize learning pathways and recommendations.</li>
          <li>Analyzing usage patterns to optimize educational content, features, and performance.</li>
          <li>Communicating important updates, service notifications, or account-related information.</li>
        </ul>
        <p className="mb-4">
          All usage is aligned with our mission to provide a secure, valuable, and engaging educational tool for career exploration in the Bitcoin mining industry.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">4. Data Storage and Security</h2>
        <p className="mb-4">
          We implement commercially reasonable security measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction. 
          These measures include encryption of data during transmission, regular security audits, restricted access to personal data to authorized personnel, and secure data backup protocols.
        </p>
        <p className="mb-4">
          While we strive to use industry-standard practices to safeguard your information, no system can guarantee absolute security. 
          We encourage you to protect your account credentials and notify us immediately if you suspect any unauthorized use.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">5. Data Sharing and Disclosure</h2>
        <p className="mb-4">
          We do not sell, rent, or trade your personal information to third parties.
          We may, however, share aggregated and anonymized data that cannot reasonably be used to identify you, for purposes such as platform analytics, research, and educational improvement.
        </p>
        <p className="mb-4">
          Any third-party services we engage must comply with strict confidentiality obligations and applicable data protection laws.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">6. Your Rights and Choices</h2>
        <p className="mb-4">
          You have certain rights regarding your personal information, subject to applicable law. These include:
        </p>
        <ul className="list-disc pl-6 mb-4">
          <li>The right to access the personal information we hold about you.</li>
          <li>The right to request the deletion of your personal information.</li>
          <li>The right to opt out of non-essential data collection and communications.</li>
          <li>The right to request a copy of your information in a portable and accessible format.</li>
        </ul>
        <p className="mb-4">
          To exercise any of these rights, please contact us using the information provided in Section 7. 
          We may request verification of your identity before fulfilling your request to protect your privacy and security.
        </p>

        <h2 className="text-2xl font-semibold text-web3-green mb-4">7. Contact Us</h2>
        <p className="mb-4">
          If you have any questions about this Privacy Policy or wish to exercise your rights, please contact our Privacy Team through our website.
        </p>
        <p className="mb-4">
          We are committed to responding to all privacy-related inquiries in a timely and transparent manner.
        </p>
      </div>
    </div>
  );
};

export default Privacy;

